// Permissions
export default {
  PLATFORM: 'platform_settings',
  POSTER: 'signages_settings',
};
